// extracted by mini-css-extract-plugin
module.exports = {"btn_label":"ContentTypeButtonMenu_btn_label__2oI3Q","menu_item_label":"ContentTypeButtonMenu_menu_item_label__o3ew3","menu_icon":"ContentTypeButtonMenu_menu_icon__1z36i"};